// extracted by mini-css-extract-plugin
module.exports = {"container":"tag_container__7wzOc","video-spin":"tag_video-spin__24vPh"};